/* eslint-disable no-console */
/* eslint-disable no-eval */
import EventAgentJS from '@hotmart/event-agent-js'
import HubMetrifyEvent from '@hotmart/event-agent-js/dist/models/hub-metrify-event'

const system = 'app_business_workspace'

EventAgentJS.mode = process.env.NODE_ENV === 'production' ? 'production' : 'staging'

export class DataHub {
  static sendDHEvent(entity, action, event = {}) {
    if (
      !eval(process.env.SEND_EVENT as string) ||
      (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging')
    ) {
      console.info(
        '⚠️ This event was not sent',
        'to send events outside the production or staging environment check the documentation:',
        // eslint-disable-next-line max-len
        'https://github.com/Hotmart-Org/app-business-workspace#how-to-test-triggering-events-in-the-development-or-approval-environment'
      )
      return null
    }

    return EventAgentJS.send({
      system,
      entity,
      action,
      event
    })
  }

  static sendDHMetrifyEvent(event: HubMetrifyEvent, element?: Element) {
    if (
      !eval(process.env.SEND_EVENT as string) ||
      (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging')
    ) {
      console.info(
        '⚠️ This event was not sent',
        'to send events outside the production or staging environment check the documentation:',
        // eslint-disable-next-line max-len
        'https://github.com/Hotmart-Org/app-business-workspace#how-to-test-triggering-events-in-the-development-or-approval-environment'
      )
      return null
    }
    return EventAgentJS.sendMetrify(
      {
        system,
        event
      },
      element
    )
  }
}
